import type { ApiMessageResponse, ContactRequestParams } from '@/core/types';

import { api, endpoints } from '@/core/api';

export async function sendEmail(data: ContactRequestParams): Promise<ApiMessageResponse> {
  return await api.post<ApiMessageResponse>(endpoints.contact, data);
}
